var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(" " + _vm._s(_vm.$ct("lock-screen-settings")) + " "),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("nfc-tag-required-on-this-device"),
                        },
                        model: {
                          value: _vm.settings.requireTagOnStart,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings, "requireTagOnStart", $$v)
                          },
                          expression: "settings.requireTagOnStart",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("scan-to-lock") },
                        model: {
                          value: _vm.settings.scanToLock,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings, "scanToLock", $$v)
                          },
                          expression: "settings.scanToLock",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.canConnectToArc1255
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct("auto-connect-to-arc1255"),
                            },
                            model: {
                              value: _vm.autoConnectArc1255,
                              callback: function ($$v) {
                                _vm.autoConnectArc1255 = $$v
                              },
                              expression: "autoConnectArc1255",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: _vm.$ct("websocket-server-url") },
                        model: {
                          value: _vm.webSocketServerUrl,
                          callback: function ($$v) {
                            _vm.webSocketServerUrl = $$v
                          },
                          expression: "webSocketServerUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "save" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }